import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import axios from "axios";

import SearchBar from "./SearchBar";
import ChatListCard from "./ChatListCard";
import "../../../../assets/css/chat/chatList.css";
import useHttp from "../../../../hooks/useHttp";
import {
  fetchChatRooms,
  loadMoreChatRooms,
} from "../../../../store/slices/chat";
import { CHAT_ROOMS_GET_URL } from "../../../../utils/api-ends";
import { gsap } from "gsap";
import LoadingGif from "../../../../assets/media/loader.gif";
import { CHAT_ROOMS_SEARCH_URL } from "../../../../utils/api-ends";
import { sending_message_ui } from "../../../../store/slices/chatUi";

const access_token = JSON.parse(localStorage.getItem("auth_token"))?.access;

const ChatListArea = () => {
  const chat_list_area = useRef(null);
  const roomAreaBox = useRef(null);
  const dispatch = useDispatch();
  const chatList = useSelector((state) => state.chat.chatRooms);
  const { sendRequests } = useHttp();
  const [isLoadMessages, setIsLoadMessages] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [rooms, setRooms] = useState([]);
  const [isFiltering, setIsFiltering] = useState(false);
  let ajaxRequest = null;
  let ajaxRequest2 = null;

  // Fetch chat rooms
  useEffect(() => {
    const response = (data) => {
      dispatch(fetchChatRooms(data));
    };

    sendRequests(
      {
        url: CHAT_ROOMS_GET_URL,
      },
      response
    );
  }, []);

  useEffect(() => {
    let chat_info_tl_1 = gsap.timeline();

    let anim_qury = gsap.utils.selector(roomAreaBox);
    let anim_qury_2 = anim_qury(".single-user-card");

    chat_info_tl_1.progress();

    for (let i = 0; anim_qury_2.length > i; i++) {
      chat_info_tl_1.from(anim_qury_2[i], { y: -50, opacity: 0 });

      chat_info_tl_1.to(anim_qury_2[i], { y: 0, opacity: 1 });
    }

    chat_info_tl_1.duration(1);
  }, [roomAreaBox, chat_list_area]);

  useEffect(() => {
    // Free scrolling and load more rooms
    if (searchVal.length === 0) {
      const handleScroll = () => {
        if (
          Math.abs(roomAreaBox.current.scrollTop) >=
            roomAreaBox.current.scrollHeight -
              roomAreaBox.current.offsetHeight &&
          chatList.pagination?.total_value > 0
        ) {
          const lastRoomId = chatList.results[chatList.results.length - 1].id;

          // Cancel  previous ajax if exists
          if (ajaxRequest) {
            ajaxRequest.cancel();
          }

          setIsLoadMessages(true); // Start loading
          // creates a new token for upcomming ajax (overwrite the previous one)
          ajaxRequest = axios.CancelToken.source(); // eslint-disable-line

          axios({
            url: CHAT_ROOMS_GET_URL.url,
            method: "get",
            params: {
              last_room_id: lastRoomId,
            },
            cancelToken: ajaxRequest.token,
            headers: {
              Authorization: `Bearer ${access_token}`,
            },
          }).then((res) => {
            dispatch(
              loadMoreChatRooms({
                results: res.data.results,
                pagination: res.data.pagination,
              })
            );
            setIsLoadMessages(false); // Stop loading
          });
        }
      };
      roomAreaBox?.current?.addEventListener("scroll", handleScroll);
      return () => {
        roomAreaBox?.current?.removeEventListener("scroll", handleScroll); // eslint-disable-line
      };
    }
  }, [roomAreaBox, chatList, searchVal]);

  // Search chat rooms
  useEffect(() => {
    if (searchVal.length > 0) {
      setRooms([]); // Reset rooms initially

      setIsFiltering(true); // Start loading

      ajaxRequest2 = axios.CancelToken.source(); // eslint-disable-line

      axios({
        url: CHAT_ROOMS_SEARCH_URL(searchVal).url,
        method: "get",
        cancelToken: ajaxRequest2.token,
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      }).then((res) => {
        setRooms(res.data);
        setIsFiltering(false); // Stop loading
      });
    } else {
      setRooms(chatList.results);
      setIsFiltering(false); // Stop loading
    }
  }, [searchVal, chatList]);

  const user_card_for_ui = () => {
    dispatch(sending_message_ui(false));
  };

  return (
    <div className="chatlist">
      <SearchBar setSearchVal={setSearchVal} />

      {isFiltering && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            src={LoadingGif}
            alt="loading"
            className="loading-gif"
            style={{ width: "25px", alignSelf: "center" }}
          />
        </div>
      )}

      <div className="chatingCardList">
        <div className="main-div" ref={roomAreaBox}>
          {rooms.map((item, index) => {
            return (
              <NavLink
                key={item.channel_id}
                to={`${item.channel_id}`}
                className={({ isActive }) =>
                  isActive
                    ? "single-user-active-card single-user-card"
                    : "single-user-card"
                }
                onClick={user_card_for_ui}
              >
                <ChatListCard key={item.channel_id} index={index} room={item} />
              </NavLink>
            );
          })}

          {isLoadMessages && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                src={LoadingGif}
                alt="loading"
                className="loading-gif"
                style={{ width: "25px", alignSelf: "center" }}
              />
            </div>
          )}

          {!isLoadMessages && chatList.pagination?.total_value === 0 && (
            <div className="no-chat-room-found">
              <p style={{ textAlign: "center", color: "grey" }}>
                No Chat Room Found
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatListArea;
